import { useAuthentication } from '@scoring/logic';
import { NotFoundPage } from '@scoring/ui';
import { Outlet } from 'react-router';

export const AdminRoute = () => {
    const { isAdmin } = useAuthentication();
    return isAdmin ? <Outlet /> : <NotFoundPage />;
};
